module.exports = __webpack_public_path__ + "img/image_1.94583fc2.jpg";